<script>
    import { onMount, createEventDispatcher } from 'svelte';
    import ImageViewer from 'iv-viewer';
    import { shareAlt, arrowRoundBack } from 'ionicons/icons/index.mjs';
    export let modal;
    export let session;
    export let tooltips;
    let loading = true;
    let error = "";
    let renderer = null;
    let viewer = null;
    let result = null;

    let image = "";
    let crop = { x: 0, y: 0 };
    let zoom = 1;
    console.log(modal);

	const dispatch = createEventDispatcher();
    onMount(async () => {
        image = modal.media.uri;
        if (modal.media.type == "360") {
            load360();
        }
        else if (modal.media.type == "image") {
            loadImage();
        }
         else if (modal.media.type == "html") {
            loadHtml();
        }
    });

    function loadImage() {
        const container = document.querySelector('#mb-preview');
        viewer = new ImageViewer(container, {});

        viewer.load(image);
    }

    function load360() {
        pannellum.viewer('panorama', {
            panorama: image,
            autoLoad: true
        });
    }

    function loadHtml() {
        fetch(modal.media.uri).then(function (response) {
            // The API call was successful!
            return response.text();
        }).then(function (html) {
            //console.log(html);
            // Convert the HTML string into a document object
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            // Get the image file
            let images = doc.getElementsByTagName("img");
            for (let i = 0; i < images.length; i++) {
                let url = new URL(images[i].src);
                if (url.search && url.origin == "https://geosync.blob.core.windows.net") {
                    url.search = session.query;
                }
                images[i].src = url;
            }
            /*if (images) {
                images.map(function (img) {
                    let url = new URL(img.src);
                    if (url.search) {
                        url.search = session.token;
                    }
                    img.src = url;
                })
            }*/

            result = doc.documentElement.innerHTML;

        }).catch(function (err) {
            // There was an error
            console.warn('Something went wrong.', err);
        });
    }

	function close() {
        if (viewer)
            viewer = viewer.destroy();
		dispatch('message', {
            type: "modal",
            modal: null
		});
    }

    function sendMessage(message) {
		dispatch('message', message);
	}
</script>

<div class="modal modal-lg active">
    <div class="modal-overlay" on:click={close} aria-label="Close"></div>
    <div id="modal-container" class="modal-container">
        <div class="modal-header">
            <div class="tile tile-centered">
                <div class="tile-content">
                    <div class="tile-title">Media</div>
                </div>
                <div class="tile-action">
                    <a href="/media?type={modal.media.type}&uri={encodeURIComponent(modal.media.uri)}" target="_blank" class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Open in new window"><i class="svg svg-light">{@html shareAlt.md}</i></a>
                    {#if modal.back}
                        <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Back" on:click|stopPropagation={(e) => {
                          e.currentTarget.blur();
                          sendMessage({
                            type: "modal",
                            data: modal.back
                          })
                        }} aria-label="Back"><i class="svg svg-light">{@html arrowRoundBack.md}</i></button>
                    {/if}
                    <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Close" on:click={close} aria-label="Close"><i class="icon icon-cross mt-1"></i></button>
                </div>
            </div>
        </div>
        <div class="modal-body">
            {#if modal.media.type == "image"}
                <div id="mb-preview" class="preview"></div>
            {:else if modal.media.type == "360"}
                <div id="panorama" class="threejs"></div>
            {:else if modal.media.type == "pdf" || modal.media.type == "link"}
                <div id="mb-preview" class="preview">
                    <iframe class="iframe" title="media" frameBorder="0" src={modal.media.uri} />
                </div>
            {:else if modal.media.type == "document"}
                <div id="mb-preview" class="preview">
                    <iframe class="iframe" title="media" frameBorder="0" src={"https://docs.google.com/viewer?url=" + encodeURIComponent(modal.media.uri) + "&embedded=true"} />
                </div>
            {:else if modal.media.type == "audio" || modal.media.type == "video"}
                <div id="mb-preview" class="preview">
                    <iframe class="iframe" title="media" frameBorder="0" src={modal.media.uri} />
                </div>
            {:else if modal.media.type == "html"}
                <div id="mb-preview" class="preview">
                {#if result}
                    {@html result }
                {/if}
                </div>
            {:else}
                <div id="mb-preview" class="preview text-center" style="padding-top:100px;">
                    <p class="empty-title h5">Preview not supported.</p>
                </div>
            {/if}
        </div>
    </div>
</div>

<style>
    .preview {
        width: 100%;
        height: 100%;
    }
    .threejs {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    .iframe {
        width: 100%;
        height: 100%;
    }
    .modal.modal-lg .modal-overlay {
        background: rgba(247, 248, 249, 0.75);
    }
    .modal.modal-lg .modal-container {
        height: 100vh;
        height: calc(var(--vh, 1vh) * 100);
        padding: 0;
    }
    .modal.modal-lg .modal-header {
        background-color: #00ab5f;
        color: #fff;
        padding: 0.2rem 0.4rem;
    }
    .modal.modal-lg .modal-header .btn.btn-link {
        color: white;
    }
    .modal.modal-lg .modal-body {
        padding: 0;
        height: calc(100vh - 2.1rem);
    }
    ::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
    }
</style>